import { render, staticRenderFns } from "./MarkedWrapper.vue?vue&type=template&id=9f7ee746&scoped=true&"
import script from "./MarkedWrapper.vue?vue&type=script&lang=js&"
export * from "./MarkedWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MarkedWrapper.vue?vue&type=style&index=0&id=9f7ee746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ee746",
  null
  
)

export default component.exports